import React, { Suspense } from 'react';
import { useHistory } from 'react-router-dom';

import { BookIcon } from 'app/components/shared/icons';
import useIsMobile from 'hooks/useIsMobile';

import useResourcesReset from '../hooks/useResourcesReset';
import ResourcesFilterBarBestOfEditions from './ResourcesFilterBarBestOfEditions';
import ResourcesFilterBarInstructions from './ResourcesFilterBarInstructions';
import ResourcesFilterBarShortcuts from './ResourcesFilterBarShortcuts';
import {
  ResourcesFilterBarContainer,
  ResourcesFilterBarInformationContainer,
  ResourcesFilterBarTitle,
  ResourcesFilterBarWrapper,
} from './styled';

const ResourcesFilterBarMobile = React.lazy(() => import('./ResourcesFilterBarMobile'));

export default function ResourcesFilterBar() {
  const history = useHistory();
  const isMobile = useIsMobile();
  const resourcesResetSearch = useResourcesReset();

  const handleTitleClick = () => {
    resourcesResetSearch();

    if (history.location.pathname !== '/resources') {
      history.push('/resources');
    }
  };

  if (isMobile)
    return (
      <Suspense fallback={<></>}>
        <ResourcesFilterBarMobile />
      </Suspense>
    );

  return (
    <ResourcesFilterBarWrapper data-best-of-sidebar="true">
      <ResourcesFilterBarContainer>
        <ResourcesFilterBarInformationContainer>
          <ResourcesFilterBarTitle onClick={handleTitleClick}>
            <BookIcon width={24} height={24} fill="var(--color-primary)" />
            Resources
          </ResourcesFilterBarTitle>
        </ResourcesFilterBarInformationContainer>
        <ResourcesFilterBarInstructions />
        <ResourcesFilterBarShortcuts />
        <ResourcesFilterBarBestOfEditions />
      </ResourcesFilterBarContainer>
    </ResourcesFilterBarWrapper>
  );
}
